import video from "../assets/Projects/RedBagOld/RedBagOld.mp4";
import child1 from "../assets/Projects/RedBagOld/child1.png";
import child2 from "../assets/Projects/RedBagOld/child2.png";
import sponsor1 from "../assets/Projects/RedBagOld/sponsor1.png";
import sponsor2 from "../assets/Projects/RedBagOld/sponsor2.png";
import SWVideo from "../assets/Projects/SleepyWoods/video.mp4";
import RetrieverVid from "../assets/Projects/Retriever/Retriever-Video.mp4";
import ChildTable1 from "../assets/Projects/RedBagNew/ChildTable1.png";
import ChildTable2 from "../assets/Projects/RedBagNew/ChildTable2.png";
import ChildTable3 from "../assets/Projects/RedBagNew/ChildTable3.png";
import ChildTable4 from "../assets/Projects/RedBagNew/ChildTable4.png";
import ChildSidebar from "../assets/Projects/RedBagNew/ChildSidebar.png";
import SponsorTable from "../assets/Projects/RedBagNew/SponsorTable.png";
import SponsorSidebar from "../assets/Projects/RedBagNew/SponsorSidebar.png";

export const RBoldImg = [
  { type: "video", src: video },
  { type: "image", src: child1 },
  { type: "image", src: child2 },
  { type: "image", src: sponsor1 },
  { type: "image", src: sponsor2 },
];

export const RBnewImg = [
  { type: "image", src: ChildTable1 },
  { type: "image", src: ChildTable2 },
  { type: "image", src: ChildTable3 },
  { type: "image", src: ChildTable4 },
  { type: "image", src: ChildSidebar },
  { type: "image", src: SponsorTable },
  { type: "image", src: SponsorSidebar },
];

export const sleepyWoodsImgs = [{ type: "video", src: SWVideo }];

export const retrieverImg = [{ type: "video", src: RetrieverVid }];
